import React from "react";
import ReactDOM from "react-dom";
import axe from "@axe-core/react";
import App from "./main/app";
if (process.env.IS_DEV_SERVER) {
    axe(React, ReactDOM, 1000);
}
ReactDOM.render(React.createElement(App, null), document.querySelector("#main"));
